<template>
  <div class="finance-over-view">
    <div class="finance-over-view-top-line">
      <div class="finance-over-view-top-line-box" style="background:linear-gradient(#1DCBBB, #1DCBBB99);">
        <i class="iconfont el-icon-damai-yingshoujine"></i>
        <div class="finance-over-view-top-line-box-info">
          <div class="finance-over-view-top-line-box-num">{{yearTotalMoneyReceivable}} <span class="finance-over-view-top-line-box-unit">万元</span></div>
          <div class="finance-over-view-top-line-box-tip">今年总应收金额</div>
        </div>
      </div>
      <div class="finance-over-view-top-line-box" style="background:linear-gradient(#3E78F4, #3E78F499);">
        <i class="iconfont el-icon-damai-huirukuan" style="font-size: 48px"></i>
        <div class="finance-over-view-top-line-box-info">
          <div class="finance-over-view-top-line-box-num">{{yearTotalMoney}} <span class="finance-over-view-top-line-box-unit">万元</span></div>
          <div class="finance-over-view-top-line-box-tip">今年总已收金额</div>
        </div>
      </div>
      <div class="finance-over-view-top-line-box" style="background:linear-gradient(#1DCBBB, #1DCBBB99);">
        <i class="iconfont el-icon-damai-kaipiao" style="font-size: 36px"></i>
        <div class="finance-over-view-top-line-box-info">
          <div class="finance-over-view-top-line-box-num">{{invoicingTotalMoney}} <span class="finance-over-view-top-line-box-unit">万元</span></div>
          <div class="finance-over-view-top-line-box-tip">今年已开票金额</div>
        </div>
      </div>
      <div class="finance-over-view-top-line-box" style="background:linear-gradient(#12C9E4, #12C9E499);">
        <i class="iconfont el-icon-damai-baozhengjin"></i>
        <div class="finance-over-view-top-line-box-info">
          <div class="finance-over-view-top-line-box-num">{{marginBalance}} <span class="finance-over-view-top-line-box-unit">万元</span></div>
          <div class="finance-over-view-top-line-box-tip">保证金余额</div>
        </div>
      </div>
      <div class="finance-over-view-top-line-box" style="background:linear-gradient(#FF6666, #FF666699);">
        <i class="iconfont el-icon-damai-yuqizhangkuan-"></i>
        <div class="finance-over-view-top-line-box-info">
          <div class="finance-over-view-top-line-box-num">{{totalMoneyOverdue}} <span class="finance-over-view-top-line-box-unit">万元</span></div>
          <div class="finance-over-view-top-line-box-tip">总逾期金额</div>
        </div>
      </div>
      <div class="finance-over-view-top-line-box" style="background:linear-gradient(#FF9F72, #FF9F7299);">
        <i class="iconfont el-icon-damai-yuqiyuanyin"></i>
        <div class="finance-over-view-top-line-box-info">
          <div class="finance-over-view-top-line-box-num">{{overdueTotal}} <span class="finance-over-view-top-line-box-unit">份</span></div>
          <div class="finance-over-view-top-line-box-tip">总逾期账单数</div>
        </div>
      </div>
    </div>

    <div class="finance-over-view-line" style="height: 390px">
      <div class="finance-over-view-line-left-box">
        <el-tabs type="border-card" v-model="incomeRingTabName">
          <el-tab-pane label="按日" name="day">
            <div class="finance-over-view-line-tab-item">
              <div style="width: 49%;">
                <common-ring commonRingId="dailyRing" width="100%" height="300px" :colorList="dailyColorList" :ringLegend="dailyRingLegend" :ringTitle='dailyTitle' :ringData='dailyInfo' v-if="incomeRingTabName === 'day'"/>
              </div>
              <div style="width: 49%;">
                <common-ring commonRingId="dailyReceivableRing" width="100%" height="300px" :colorList="dailyReceivableColorList" :ringLegend="dailyReceivableRingLegend" :ringTitle='dailyReceivableTitle' :ringData='dailyReceivableInfo' v-if="incomeRingTabName === 'day'"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="按月" name="month">
            <div class="finance-over-view-line-tab-item">
              <div style="width: 49%;">
                <common-ring commonRingId="monthlyRing" height="300px" :colorList="monthColorList" :ringLegend="monthRingLegend" :ringTitle='monthTitle' :ringData='monthInfo' v-if="incomeRingTabName === 'month'"/>
              </div>
              <div style="width: 49%;">
                <common-ring commonRingId="monthlyReceivableRing" height="300px" :colorList="monthReceivableColorList" :ringLegend="monthReceivableRingLegend" :ringTitle='monthReceivableTitle' :ringData='monthReceivableInfo' v-if="incomeRingTabName === 'month'"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="按季" name="season">
            <div class="finance-over-view-line-tab-item">
              <div style="width: 49%;">
                <common-ring commonRingId="seasonRing" height="300px" :colorList="seasonColorList" :ringLegend="seasonRingLegend" :ringTitle='seasonTitle' :ringData='seasonInfo' v-if="incomeRingTabName === 'season'"/>
              </div>
              <div style="width: 49%;">
                <common-ring commonRingId="seasonReceivableRing" height="300px" :colorList="seasonReceivableColorList" :ringLegend="seasonReceivableRingLegend" :ringTitle='seasonReceivableTitle' :ringData='seasonReceivableInfo' v-if="incomeRingTabName === 'season'"/>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="按年" name="year">
            <div class="finance-over-view-line-tab-item">
              <div style="width: 49%;">
                <common-ring commonRingId="yearRing" height="300px" :colorList="yearColorList" :ringLegend="yearRingLegend" :ringTitle='yearTitle' :ringData='yearInfo' v-if="incomeRingTabName === 'year'"/>
              </div>
              <div style="width: 49%;">
                <common-ring commonRingId="yearReceivableRing" height="300px" :colorList="yearReceivableColorList" :ringLegend="yearReceivableRingLegend" :ringTitle='yearReceivableTitle' :ringData='yearReceivableInfo' v-if="incomeRingTabName === 'year'"/>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="finance-over-view-line-right-box">
        <el-tabs type="border-card" v-model="invoiceRingTabName">
          <el-tab-pane label="日开票" name="day">
            <div style="width: 100%;">
              <common-ring commonRingId="dailyInvoiceRing" height="300px" :colorList="dailyInvoiceColorList" :ringLegend="dailyInvoiceRingLegend" :ringTitle='dailyInvoiceTitle' :ringData='dailyInvoiceInfo' v-if="invoiceRingTabName === 'day'"/>
            </div>
          </el-tab-pane>
          <el-tab-pane label="月开票" name="month">
            <div style="width: 100%;">
              <common-ring commonRingId="monthlyInvoiceRing" height="300px" :colorList="monthInvoiceColorList" :ringLegend="monthInvoiceRingLegend" :ringTitle='monthInvoiceTitle' :ringData='monthInvoiceInfo' v-if="invoiceRingTabName === 'month'"/>
            </div>
          </el-tab-pane>
          <el-tab-pane label="季开票" name="season">
            <div style="width: 100%;">
              <common-ring commonRingId="seasonInvoiceRing" height="300px" :colorList="seasonInvoiceColorList" :ringLegend="seasonInvoiceRingLegend" :ringTitle='seasonInvoiceTitle' :ringData='seasonInvoiceInfo' v-if="invoiceRingTabName === 'season'"/>
            </div>
          </el-tab-pane>
          <el-tab-pane label="年开票" name="year">
            <div style="width: 100%;">
              <common-ring commonRingId="yearInvoiceRing" height="300px" :colorList="yearInvoiceColorList" :ringLegend="yearInvoiceRingLegend" :ringTitle='yearInvoiceTitle' :ringData='yearInvoiceInfo' v-if="invoiceRingTabName === 'year'"/>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <div class="finance-over-view-line" style="height: 290px;margin: 10px 0 20px 0;">
      <el-tabs type="border-card" v-model="incomeLineTabName" style="width: 100%">
        <el-tab-pane label="总览" name="all">
          <div style="width: 100%;">
            <chart-time-select @getData="getAllHistoryData" v-if="incomeLineTabName === 'all'"/>
            <common-line style="z-index: 1000" gridTop="24%" :lineId='"grossIncome"' :height='"220px"' :lineTitle='grossIncomeTitle' :legendData="grossIncomeLegendData" :xAxis="grossIncomeXAxis" :yAxis='commonLineYAxis' :series='grossIncomeSeries' v-if="incomeLineTabName === 'all'"/>
          </div>
        </el-tab-pane>
        <el-tab-pane label="租金" name="rent">
          <div style="width: 100%;">
            <chart-time-select @getData="getLeaseHistoryData" v-if="incomeLineTabName === 'rent'"/>
            <common-line style="z-index: 1000" :lineId='"rentLine"' :height='"220px"' :lineTitle='rentTitle' :legendData="rentLegendData" :xAxis="rentXAxis" :yAxis='commonLineYAxis' :series='rentSeries' v-if="incomeLineTabName === 'rent'"/>
          </div>
        </el-tab-pane>
        <el-tab-pane label="物业费" name="property">
          <div style="width: 100%;">
            <chart-time-select @getData="getPropertyHistoryData" v-if="incomeLineTabName === 'property'"/>
            <common-line style="z-index: 1000" :lineId='"propertyLine"' :height='"220px"' :lineTitle='propertyTitle' :legendData="propertyLegendData" :xAxis="propertyXAxis" :yAxis='commonLineYAxis' :series='propertySeries' v-if="incomeLineTabName === 'property'"/>
          </div>
        </el-tab-pane>
        <el-tab-pane label="停车费" name="park">
          <div style="width: 100%;">
            <chart-time-select @getData="getParkingHistoryData" v-if="incomeLineTabName === 'park'"/>
            <common-line style="z-index: 1000" :lineId='"parkingLine"' :height='"220px"' :lineTitle='parkingTitle' :legendData="parkingLegendData" :xAxis="parkingXAxis" :yAxis='commonLineYAxis' :series='parkingSeries' v-if="incomeLineTabName === 'park'"/>
          </div>
        </el-tab-pane>
        <el-tab-pane label="电费" name="electronic">
          <div style="width: 100%;">
            <chart-time-select @getData="getElectronicAllHistoryData" v-if="incomeLineTabName === 'electronic'"/>
            <common-line style="z-index: 1000" :lineId='"electronicLine"' :height='"220px"' :lineTitle='electronicTitle' :legendData="electronicLegendData" :xAxis="electronicXAxis" :yAxis='commonLineYAxis' :series='electronicSeries' v-if="incomeLineTabName === 'electronic'"/>
          </div>
        </el-tab-pane>
        <el-tab-pane label="其他" name="other">
          <div style="width: 100%;">
            <chart-time-select @getData="getOtherHistoryData" v-if="incomeLineTabName === 'other'"/>
            <common-line style="z-index: 1000" :lineId='"otherLine"' :height='"220px"' :lineTitle='otherTitle' :legendData="otherLegendData" :xAxis="otherXAxis" :yAxis='commonLineYAxis' :series='otherSeries' v-if="incomeLineTabName === 'other'"/>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--    <div class="finance-over-view-line" style="margin: 10px 0 20px 0;padding: 10px;position: relative;border: 1px solid #eeeeee;border-radius: 10px;">-->
    <!--      <div style="position: absolute;top: 15px;right: 0;left: 0;margin: 0 auto;z-index: 1001;width: 180px;">-->
    <!--        <el-switch-->
    <!--          v-model="depositRadio"-->
    <!--          active-text="年度"-->
    <!--          inactive-text="月度">-->
    <!--        </el-switch>-->
    <!--      </div>-->
    <!--      <common-line style="z-index: 1000" :lineId='"depositLine"' :height='"220px"' :lineTitle='depositTitle' :legendData="depositLegendData" :xAxis="depositXAxis" :yAxis='commonLineYAxis' :series='depositSeries' />-->
    <!--    </div>-->

    <div class="finance-over-view-line" style="margin: 20px 0;height: 275px;display: flex;justify-content: flex-start;flex-direction: column;padding: 10px 10px;border: 1px solid #DCDFE6;box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);overflow: hidden;">
      <div style="display: flex;justify-content: space-between;margin-bottom: 9px;">
        <div style="font-size: 16px;font-weight: 500;">逾期未结算账单 ({{dueOverTotal}})</div>
        <div style="display: flex;justify-content: flex-end;align-items: center;">
          <el-pagination
            @current-change="dueOverCurrentChange"
            @size-change="handleSizeChange"
            :page-size="dueOverPageSize"
            :page-sizes="[5, 10, 20, 50, 100]"
            layout="prev, pager, next, sizes"
            :total="dueOverTotal">
          </el-pagination>
          <button-export
            :href="exportUrl"
            download="download.xls"
            style="margin: 0 0 0 8px"
            :beforeDownload="beforeDownload"
            value="导出"/>
        </div>
      </div>
      <el-table
        :data="dueOverTableData"
        :height="218"
        style="width: 100%">
        <el-table-column
          label="住户名称">
          <template slot-scope="scope">
            <span>{{ scope.row.enterpriseName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="房间号">
          <template slot-scope="scope">
            <span>{{ scope.row.roomInfoName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="费用类型">
          <template slot-scope="scope">
            <span>{{ scope.row.feeType }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="应收金额(元)">
          <template slot-scope="scope">
            <span>{{ scope.row.payMoney }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="逾期天数(天)">
          <template slot-scope="scope">
            <span>{{ scope.row.overDayCount }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="联系人"
          width="180">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p v-if="scope.row.contactPeople.length>0" style="min-width: 180px;">{{ scope.row.contactPeople[0].name }} / {{ scope.row.contactPeople[0].phone }} </p>
              <p v-else>暂无联系人</p>
              <div slot="reference" class="name-wrapper">
                <span style="color: #00a0e6">联系人</span>
                <!--<el-tag size="medium">{{ scope.row.name }}</el-tag>-->
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="通知单">
          <template slot-scope="scope">
            <span @click="showNoticeChoose(scope.row)" style="color: #00a0e6;cursor: pointer;">生成通知单</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="通知单模板选择" :visible.sync="noticeDialogFormVisible" width="500px" class="contractDialogForm"
               v-loading="downloadNoticeLoading"
               element-loading-text="通知单生成中，请耐心等待"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)">
      <div>
        <div v-for="item in noticeTemplateList" class="contractDialogLine" :key="item.templateName">
          <div>{{item.templateName}}</div>
          <div class="operationBox">
            <span style="margin-right: 20px;" @click="previewContract(item.path, item.fileName, item.code)">预览</span>
            <span @click="downloadContract(item.path, item.fileName, item.code)">下载</span>
          </div>
        </div>
        <div v-if="noticeTemplateList.length === 0" style="text-align: center;line-height: 30px;">暂无通知单模板</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../../api/Finance";
import { errorHandler } from "../../../utils/errorHandler";
//   import ControllerPie from '../../../components/Echarts/Pie/Pie/controllerPie'
import commonHorizontalBar from "../../../components/Echarts/Bar/commonHorizontalBar";
import commonRing from "../../../components/Echarts/Pie/Pie/commonRing";
import commonLine from "../../../components/Echarts/Line/commonLine";
import CommonStackingBar from "../../../components/Echarts/Bar/commonStackingBar";
import { nError } from "../../../utils/notice";
import ChartTimeSelect from "../../../components/Echarts/ChartTimeSelect/ChartTimeSelect";
import ButtonExport from "../../../components/Button/ButtonExport";
import { bus } from "../../../utils/bus";

//   import financePersonnelPie from '../../../components/Echarts/Pie/Pie/financePersonnelPie'
//   import financeTemperatureMeasurement from '../../../components/Echarts/Line/financeTemperatureMeasurement'
//   import ElectronicStackingBar from '../../../components/Echarts/Bar/StackingBar/ElectronicStackingBar'
//   import ElectronicMonthStackingBar from '../../../components/Echarts/Bar/StackingBar/ElectronicMonthStackingBar'

export default {
  components: {
    ButtonExport,
    ChartTimeSelect,
    CommonStackingBar,
    commonRing,
    commonHorizontalBar,
    commonLine,
  },
  name: "finance-over-view",
  data() {
    return {
      yearTotalMoneyReceivable: 0,
      yearTotalMoney: 0,
      invoicingTotalMoney: 0,
      marginBalance: 0,
      totalMoneyOverdue: 0,
      overdueTotal: 0,

      incomeRingTabName: "day",
      invoiceRingTabName: "day",
      incomeLineTabName: "all",
      // 当日收入
      dailyTitle: "当日收入(0)",
      dailyRingLegend: {
        left: "center",
        bottom: -5,
      },
      dailyColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      dailyInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
        { name: "电费", value: 0 },
        { name: "停车费", value: 0 },
        { name: "预约费", value: 0 },
        { name: "报修费", value: 0 },
        { name: "自定义收费", value: 0 },
        { name: "报名费", value: 0 },
      ],
      // 当月收入
      monthTitle: "当月收入(0)",
      monthRingLegend: {
        left: "center",
        bottom: -5,
      },
      monthColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      monthInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
        { name: "电费", value: 0 },
        { name: "停车费", value: 0 },
        { name: "预约费", value: 0 },
        { name: "报修费", value: 0 },
        { name: "自定义收费", value: 0 },
        { name: "报名费", value: 0 },
      ],
      // 当季收入
      seasonTitle: "当季收入(0)",
      seasonRingLegend: {
        left: "center",
        bottom: -5,
      },
      seasonColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      seasonInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
        { name: "电费", value: 0 },
        { name: "停车费", value: 0 },
        { name: "预约费", value: 0 },
        { name: "报修费", value: 0 },
        { name: "自定义收费", value: 0 },
        { name: "报名费", value: 0 },
      ],
      // 当年收入
      yearTitle: "当年收入(0)",
      yearRingLegend: {
        left: "center",
        bottom: -5,
      },
      yearColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      yearInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
        { name: "电费", value: 0 },
        { name: "停车费", value: 0 },
        { name: "预约费", value: 0 },
        { name: "报修费", value: 0 },
        { name: "自定义收费", value: 0 },
        { name: "报名费", value: 0 },
      ],

      // 当日应收
      dailyReceivableTitle: "当日应收(0)",
      dailyReceivableRingLegend: {
        left: "center",
        bottom: -5,
      },
      dailyReceivableColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      dailyReceivableInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
      ],
      // 当月应收
      monthReceivableTitle: "当月应收(0)",
      monthReceivableRingLegend: {
        left: "center",
        bottom: -5,
      },
      monthReceivableColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      monthReceivableInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
      ],
      // 当季应收
      seasonReceivableTitle: "当季应收(0)",
      seasonReceivableRingLegend: {
        left: "center",
        bottom: -5,
      },
      seasonReceivableColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      seasonReceivableInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
      ],
      // 当年应收
      yearReceivableTitle: "当年应收(0)",
      yearReceivableRingLegend: {
        left: "center",
        bottom: -5,
      },
      yearReceivableColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      yearReceivableInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
      ],

      // 当日收入
      dailyInvoiceTitle: "当日开票金额(0)",
      dailyInvoiceRingLegend: {
        left: "center",
        bottom: -5,
      },
      dailyInvoiceColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      dailyInvoiceInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
        { name: "电费", value: 0 },
        { name: "停车费", value: 0 },
        { name: "预约费", value: 0 },
        { name: "报修费", value: 0 },
        { name: "自定义收费", value: 0 },
        { name: "报名费", value: 0 },
      ],
      // 当月收入
      monthInvoiceTitle: "当月开票金额(0)",
      monthInvoiceRingLegend: {
        left: "center",
        bottom: -5,
      },
      monthInvoiceColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      monthInvoiceInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
        { name: "电费", value: 0 },
        { name: "停车费", value: 0 },
        { name: "预约费", value: 0 },
        { name: "报修费", value: 0 },
        { name: "自定义收费", value: 0 },
        { name: "报名费", value: 0 },
      ],
      // 当季收入
      seasonInvoiceTitle: "当季开票金额(0)",
      seasonInvoiceRingLegend: {
        left: "center",
        bottom: -5,
      },
      seasonInvoiceColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      seasonInvoiceInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
        { name: "电费", value: 0 },
        { name: "停车费", value: 0 },
        { name: "预约费", value: 0 },
        { name: "报修费", value: 0 },
        { name: "自定义收费", value: 0 },
        { name: "报名费", value: 0 },
      ],
      // 当年收入
      yearInvoiceTitle: "当年开票金额(0)",
      yearInvoiceRingLegend: {
        left: "center",
        bottom: -5,
      },
      yearInvoiceColorList: [
        "#5B9BD5",
        "#ED7D31",
        "#C2A753",
        "#4BB66E",
        "#FFA336",
        "#53A5BC",
        "#47C4CA",
        "#77E5BF",
      ],
      yearInvoiceInfo: [
        { name: "租金", value: 0 },
        { name: "物业", value: 0 },
        { name: "电费", value: 0 },
        { name: "停车费", value: 0 },
        { name: "预约费", value: 0 },
        { name: "报修费", value: 0 },
        { name: "自定义收费", value: 0 },
        { name: "报名费", value: 0 },
      ],

      // 总收入
      grossIncomeTitle: "总收入",
      grossIncomeLegendData: [],
      grossIncomeXAxis: {},
      grossIncomeSeries: [],
      incomeRadio: false,

      // 租金概览
      rentTitle: "租金收入",
      rentLegendData: ["应收", "实收"],
      rentXAxis: {},
      rentSeries: [],
      rentRadio: false,

      // 物业概览
      propertyTitle: "物业费收入",
      propertyLegendData: ["应收", "实收"],
      propertyXAxis: {},
      propertySeries: [],
      propertyRadio: false,

      // 保证金余额
      depositTitle: "保证金余额",
      depositLegendData: ["租金保证金", "其他保证金"],
      depositXAxis: {
        type: "category",
        name: "日期",
        data: [],
      },
      depositSeries: [
        {
          name: "租金保证金",
          type: "line",
          stack: "总量",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#00A0E6",
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#00A0E6",
              },
              {
                offset: 1,
                color: "#ffe",
              },
            ]),
          },
          data: [0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "其他保证金",
          type: "line",
          stack: "总量",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#4BB66E",
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#4BB66E",
              },
              {
                offset: 1,
                color: "#ffe",
              },
            ]),
          },
          data: [0, 0, 0, 0, 0, 0, 0],
        },
      ],
      depositRadio: false,

      // 停车费收入
      parkingTitle: "停车费收入",
      parkingLegendData: ["包月", "临停"],
      parkingXAxis: {},
      parkingSeries: [],
      parkingRadio: false,

      // 电费收入
      electronicTitle: "电费收入",
      electronicLegendData: [],
      electronicXAxis: {},
      electronicSeries: [],
      electronicRadio: false,

      // 其他收入
      otherTitle: "其他收入",
      otherLegendData: ["预约费", "报修费"],
      otherXAxis: {
        type: "category",
        name: "日期",
        data: ["02-24", "02-25", "02-26", "02-27", "02-28", "02-29", "03-01"],
      },
      otherSeries: [
        {
          name: "预约费",
          type: "line",
          stack: "总量",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#00A0E6",
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#00A0E6",
              },
              {
                offset: 1,
                color: "#ffe",
              },
            ]),
          },
          data: [60, 20, 30, 10, 40, 60, 90],
        },
        {
          name: "报修费",
          type: "line",
          stack: "总量",
          // areaStyle: {},
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          itemStyle: {
            color: "#FFA336",
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: "#FFA336",
              },
              {
                offset: 1,
                color: "#ffe",
              },
            ]),
          },
          data: [20, 70, 60, 20, 10, 40, 30],
        },
      ],
      otherRadio: false,

      commonLineYAxis: [
        {
          type: "value",
          name: "金额(元)",
          splitLine: {
            show: false,
          },
        },
      ],

      // 逾期未结算客户相关字段
      dueOverTotal: 0,
      dueOverPageSize: 5,
      dueOverPageNum: 1,
      dueOverTableData: [],

      downloadNoticeLoading: false,
      noticeDialogFormVisible: false,
      noticeTemplateList: [],
      currentDueOverData: {},

      exportUrl: "",
    };
  },
  created() {
    this.getDataOverview();
    this.getPeriodData();
    this.getPeriodReceivableData();
    this.getPeriodInvoicingData();

    this.getOverdueData();
  },
  mounted() {},
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportOverdueData}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}`;
    },
    // 获取统计数据
    getDataOverview() {
      this.$axios
        .get(api.getDataOverview, {})
        .then((res) => {
          let data = res.data.data;
          this.yearTotalMoneyReceivable = data.yearTotalMoneyReceivable;
          this.yearTotalMoney = data.yearTotalMoney;
          this.invoicingTotalMoney = data.invoicingTotalMoney;
          this.marginBalance = data.marginBalance;
          this.totalMoneyOverdue = data.totalMoneyOverdue;
          this.overdueTotal = data.overdueTotal;
        })
        .catch(errorHandler("获取数据失败"));
    },
    // 获取数据   总
    getAllHistoryData(type, startTime, endTime) {
      this.$axios
        .post(`${api.getAllHistoryData}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY",
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let XAxisArr = [];
            let grossIncomeSeries = [];
            let electronicSeries = [];
            let venueSeries = [];
            let repairSeries = [];
            data.map((v) => {
              grossIncomeSeries.push(v.totalMoney);
              electronicSeries.push(v.electricMoney);
              venueSeries.push(v.venueMoney);
              repairSeries.push(v.interactionMoney);
              XAxisArr.push(v.time);
            });
            // 总收入
            this.grossIncomeXAxis = {
              type: "category",
              name: "日期",
              data: XAxisArr,
            };
            this.grossIncomeSeries = [
              {
                name: "",
                type: "line",
                stack: "实收",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                itemStyle: {
                  color: "#00A0E6",
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#00A0E6",
                    },
                    {
                      offset: 1,
                      color: "#ffe",
                    },
                  ]),
                },
                data: grossIncomeSeries,
              },
            ];
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 获取电费数据
    getElectronicAllHistoryData(type, startTime, endTime) {
      this.$axios
        .post(`${api.getAllHistoryData}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY",
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let XAxisArr = [];
            let grossIncomeSeries = [];
            let electronicSeries = [];
            let venueSeries = [];
            let repairSeries = [];
            data.map((v) => {
              grossIncomeSeries.push(v.totalMoney);
              electronicSeries.push(v.electricMoney);
              venueSeries.push(v.venueMoney);
              repairSeries.push(v.interactionMoney);
              XAxisArr.push(v.time);
            });
            // 电费
            this.electronicXAxis = {
              type: "category",
              name: "日期",
              data: XAxisArr,
            };
            this.electronicSeries = [
              {
                name: "",
                type: "line",
                stack: "实收",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                itemStyle: {
                  color: "#00A0E6",
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#00A0E6",
                    },
                    {
                      offset: 1,
                      color: "#ffe",
                    },
                  ]),
                },
                data: electronicSeries,
              },
            ];
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 获取其他收入数据
    getOtherHistoryData(type, startTime, endTime) {
      this.$axios
        .post(`${api.getAllHistoryData}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY",
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let XAxisArr = [];
            let grossIncomeSeries = [];
            let electronicSeries = [];
            let venueSeries = [];
            let repairSeries = [];
            data.map((v) => {
              grossIncomeSeries.push(v.totalMoney);
              electronicSeries.push(v.electricMoney);
              venueSeries.push(v.venueMoney);
              repairSeries.push(v.interactionMoney);
              XAxisArr.push(v.time);
            });
            // 其他
            this.otherXAxis = {
              type: "category",
              name: "日期",
              data: XAxisArr,
            };
            this.otherSeries = [
              {
                name: "预约费",
                type: "line",
                stack: "总量",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                itemStyle: {
                  color: "#00A0E6",
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#00A0E6",
                    },
                    {
                      offset: 1,
                      color: "#ffe",
                    },
                  ]),
                },
                data: venueSeries,
              },
              {
                name: "报修费",
                type: "line",
                stack: "总量",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                itemStyle: {
                  color: "#FFA336",
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#FFA336",
                    },
                    {
                      offset: 1,
                      color: "#ffe",
                    },
                  ]),
                },
                data: repairSeries,
              },
            ];
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 获取租金
    getLeaseHistoryData(type, startTime, endTime) {
      this.$axios
        .post(`${api.getLeaseHistoryData}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY",
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let XAxisArr = [];
            let rentReceivableSeries = [];
            let rentReceivedSeries = [];
            let propertyReceivableSeries = [];
            let propertyReceivedSeries = [];
            data.map((v) => {
              rentReceivableSeries.push(v.rentReceivable);
              rentReceivedSeries.push(v.rentReceived);
              propertyReceivableSeries.push(v.propertyReceivable);
              propertyReceivedSeries.push(v.propertyReceived);
              XAxisArr.push(v.time);
            });
            this.rentXAxis = {
              type: "category",
              name: "日期",
              data: XAxisArr,
            };
            this.rentSeries = [
              {
                name: "实收",
                type: "line",
                stack: "实收",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                itemStyle: {
                  color: "#00A0E6",
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#00A0E6",
                    },
                    {
                      offset: 1,
                      color: "#ffe",
                    },
                  ]),
                },
                data: rentReceivedSeries,
              },
              {
                name: "应收",
                type: "line",
                stack: "应收",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                itemStyle: {
                  color: "#ED7D31",
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#ED7D31",
                    },
                    {
                      offset: 1,
                      color: "#ffe",
                    },
                  ]),
                },
                data: rentReceivableSeries,
              },
            ];
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 获取物业费
    getPropertyHistoryData(type, startTime, endTime) {
      this.$axios
        .post(`${api.getLeaseHistoryData}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY",
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let XAxisArr = [];
            let rentReceivableSeries = [];
            let rentReceivedSeries = [];
            let propertyReceivableSeries = [];
            let propertyReceivedSeries = [];
            data.map((v) => {
              rentReceivableSeries.push(v.rentReceivable);
              rentReceivedSeries.push(v.rentReceived);
              propertyReceivableSeries.push(v.propertyReceivable);
              propertyReceivedSeries.push(v.propertyReceived);
              XAxisArr.push(v.time);
            });
            // 物业费
            this.propertyXAxis = {
              type: "category",
              name: "日期",
              data: XAxisArr,
            };
            this.propertySeries = [
              {
                name: "实收",
                type: "line",
                stack: "实收",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                itemStyle: {
                  color: "#00A0E6",
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#00A0E6",
                    },
                    {
                      offset: 1,
                      color: "#ffe",
                    },
                  ]),
                },
                data: propertyReceivedSeries,
              },
              {
                name: "应收",
                type: "line",
                stack: "应收",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                itemStyle: {
                  color: "#ED7D31",
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#ED7D31",
                    },
                    {
                      offset: 1,
                      color: "#ffe",
                    },
                  ]),
                },
                data: propertyReceivableSeries,
              },
            ];
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 停车费
    getParkingHistoryData(type, startTime, endTime) {
      this.$axios
        .post(`${api.getParkingHistoryData}`, {
          startTime: startTime || "",
          endTime: endTime || "",
          timeType: type || "DAY",
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let XAxisArr = [];
            let monthlySeries = [];
            let temporarySeries = [];
            data.map((v) => {
              monthlySeries.push(v.monthlyStopMoney);
              temporarySeries.push(v.temporaryStopMoney);
              XAxisArr.push(v.time);
            });
            this.parkingXAxis = {
              type: "category",
              name: "日期",
              data: XAxisArr,
            };
            this.parkingSeries = [
              {
                name: "包月",
                type: "line",
                stack: "总量",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                itemStyle: {
                  color: "#00A0E6",
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#00A0E6",
                    },
                    {
                      offset: 1,
                      color: "#ffe",
                    },
                  ]),
                },
                data: monthlySeries,
              },
              {
                name: "临停",
                type: "line",
                stack: "总量",
                // areaStyle: {},
                smooth: true,
                symbol: "circle",
                symbolSize: 5,
                sampling: "average",
                itemStyle: {
                  color: "#4BB66E",
                },
                areaStyle: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#4BB66E",
                    },
                    {
                      offset: 1,
                      color: "#ffe",
                    },
                  ]),
                },
                data: temporarySeries,
              },
            ];
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 获取收入
    getPeriodData() {
      this.$axios
        .get(api.getPeriodData, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map((v) => {
              if (v.timeType === "DAY") {
                this.dailyTitle = `当日收入(${v.totalMoney}元)`;
                this.dailyInfo = [
                  { name: "租金", value: v.rentMoney },
                  { name: "物业", value: v.propertyMoney },
                  { name: "电费", value: v.electricMoney },
                  { name: "停车费", value: v.parkingMoney },
                  { name: "预约费", value: v.venueMoney },
                  { name: "报修费", value: v.interactionMoney },
                  { name: "自定义收费", value: v.paymentMoney },
                  { name: "报名费", value: v.eventMoney },
                ];
              } else if (v.timeType === "MONTH") {
                this.monthTitle = `当月收入(${v.totalMoney}元)`;
                this.monthInfo = [
                  { name: "租金", value: v.rentMoney },
                  { name: "物业", value: v.propertyMoney },
                  { name: "电费", value: v.electricMoney },
                  { name: "停车费", value: v.parkingMoney },
                  { name: "预约费", value: v.venueMoney },
                  { name: "报修费", value: v.interactionMoney },
                  { name: "自定义收费", value: v.paymentMoney },
                  { name: "报名费", value: v.eventMoney },
                ];
              } else if (v.timeType === "QUARTER") {
                this.seasonTitle = `当季收入(${v.totalMoney}元)`;
                this.seasonInfo = [
                  { name: "租金", value: v.rentMoney },
                  { name: "物业", value: v.propertyMoney },
                  { name: "电费", value: v.electricMoney },
                  { name: "停车费", value: v.parkingMoney },
                  { name: "预约费", value: v.venueMoney },
                  { name: "报修费", value: v.interactionMoney },
                  { name: "自定义收费", value: v.paymentMoney },
                  { name: "报名费", value: v.eventMoney },
                ];
              } else if (v.timeType === "YEAR") {
                this.yearTitle = `当年收入(${v.totalMoney}元)`;
                this.yearInfo = [
                  { name: "租金", value: v.rentMoney },
                  { name: "物业", value: v.propertyMoney },
                  { name: "电费", value: v.electricMoney },
                  { name: "停车费", value: v.parkingMoney },
                  { name: "预约费", value: v.venueMoney },
                  { name: "报修费", value: v.interactionMoney },
                  { name: "自定义收费", value: v.paymentMoney },
                  { name: "报名费", value: v.eventMoney },
                ];
              }
            });
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 获取应收数据(环形图)
    getPeriodReceivableData() {
      this.$axios
        .get(api.getPeriodReceivableData, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map((v) => {
              if (v.timeType === "DAY") {
                this.dailyReceivableTitle = `当日应收(${v.totalReceivableMoney}元)`;
                this.dailyReceivableInfo = [
                  { name: "租金", value: v.rentReceivableMoney },
                  { name: "物业", value: v.propertyReceivableMoney },
                ];
              } else if (v.timeType === "MONTH") {
                this.monthReceivableTitle = `当月应收(${v.totalReceivableMoney}元)`;
                this.monthReceivableInfo = [
                  { name: "租金", value: v.rentReceivableMoney },
                  { name: "物业", value: v.propertyReceivableMoney },
                ];
              } else if (v.timeType === "QUARTER") {
                this.seasonReceivableTitle = `当季应收(${v.totalReceivableMoney}元)`;
                this.seasonReceivableInfo = [
                  { name: "租金", value: v.rentReceivableMoney },
                  { name: "物业", value: v.propertyReceivableMoney },
                ];
              } else if (v.timeType === "YEAR") {
                this.yearReceivableTitle = `当年应收(${v.totalReceivableMoney}元)`;
                this.yearReceivableInfo = [
                  { name: "租金", value: v.rentReceivableMoney },
                  { name: "物业", value: v.propertyReceivableMoney },
                ];
              }
            });
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 获取开票金额数据(环形图)
    getPeriodInvoicingData() {
      this.$axios
        .get(api.getPeriodInvoicingData, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map((v) => {
              if (v.timeType === "DAY") {
                this.dailyInvoiceTitle = `当日开票金额(${v.totalInvoicingMoney}元)`;
                this.dailyInvoiceInfo = [
                  { name: "租金", value: v.rentInvoicingMoney },
                  { name: "物业", value: v.propertyInvoicingMoney },
                  { name: "电费", value: v.electricInvoicingMoney },
                  { name: "停车费", value: v.parkingInvoicingMoney },
                  { name: "预约费", value: v.reverseInvoicingMoney },
                  { name: "报修费", value: v.repairInvoicingMoney },
                  { name: "自定义收费", value: v.paymentInvoicingMoney },
                  { name: "报名费", value: v.eventInvoicingMoney },
                ];
              } else if (v.timeType === "MONTH") {
                this.monthInvoiceTitle = `当月开票金额(${v.totalInvoicingMoney}元)`;
                this.monthInvoiceInfo = [
                  { name: "租金", value: v.rentInvoicingMoney },
                  { name: "物业", value: v.propertyInvoicingMoney },
                  { name: "电费", value: v.electricInvoicingMoney },
                  { name: "停车费", value: v.parkingInvoicingMoney },
                  { name: "预约费", value: v.reverseInvoicingMoney },
                  { name: "报修费", value: v.repairInvoicingMoney },
                  { name: "自定义收费", value: v.paymentInvoicingMoney },
                  { name: "报名费", value: v.eventInvoicingMoney },
                ];
              } else if (v.timeType === "QUARTER") {
                this.seasonInvoiceTitle = `当季开票金额(${v.totalInvoicingMoney}元)`;
                this.seasonInvoiceInfo = [
                  { name: "租金", value: v.rentInvoicingMoney },
                  { name: "物业", value: v.propertyInvoicingMoney },
                  { name: "电费", value: v.electricInvoicingMoney },
                  { name: "停车费", value: v.parkingInvoicingMoney },
                  { name: "预约费", value: v.reverseInvoicingMoney },
                  { name: "报修费", value: v.repairInvoicingMoney },
                  { name: "自定义收费", value: v.paymentInvoicingMoney },
                  { name: "报名费", value: v.eventInvoicingMoney },
                ];
              } else if (v.timeType === "YEAR") {
                this.yearInvoiceTitle = `当年开票金额(${v.totalInvoicingMoney}元)`;
                this.yearInvoiceInfo = [
                  { name: "租金", value: v.rentInvoicingMoney },
                  { name: "物业", value: v.propertyInvoicingMoney },
                  { name: "电费", value: v.electricInvoicingMoney },
                  { name: "停车费", value: v.parkingInvoicingMoney },
                  { name: "预约费", value: v.reverseInvoicingMoney },
                  { name: "报修费", value: v.repairInvoicingMoney },
                  { name: "自定义收费", value: v.paymentInvoicingMoney },
                  { name: "报名费", value: v.eventInvoicingMoney },
                ];
              }
            });
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    dueOverCurrentChange(val) {
      this.dueOverPageNum = val;
      this.getOverdueData();
    },

    handleSizeChange(val) {
      this.dueOverPageSize = val;
      this.dueOverPageNum = 1;
      this.getOverdueData();
    },

    // 逾期未结算
    getOverdueData() {
      this.$axios
        .post(api.getOverdueData, {
          pageNum: this.dueOverPageNum,
          pageSize: this.dueOverPageSize,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.dueOverTableData = data.list;
            this.dueOverTotal = data.total;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },

    // 选择催款单
    showNoticeChoose(data) {
      this.currentDueOverData = data;
      this.noticeDialogFormVisible = true;
      this.getTemplateList();
    },

    // 获取催款单列表
    getTemplateList() {
      this.$axios
        .get(api.getTemplateList, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.noticeTemplateList = data;
          }
        })
        .catch(errorHandler("获取催款单失败"));
    },

    // 催款单预览
    previewContract(path, fileName, code) {
      this.downloadNoticeLoading = true;
      this.$axios
        .post(api.createLeaseUrl, {
          billCode: this.currentDueOverData.code,
          fileName: fileName,
          templateUrl: path,
          templateCode: code,
        })
        .then((res) => {
          this.downloadNoticeLoading = false;
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (data) {
              window.open(
                "http://view.officeapps.live.com/op/view.aspx?src=" + data,
                "_blank"
              );
            } else {
              nError("预览失败");
            }
          }
        })
        .catch(errorHandler("预览失败"))
        .then(() => {
          this.downloadNoticeLoading = false;
        });
    },
    // 催款单生成并下载
    downloadContract(path, fileName, code) {
      this.downloadNoticeLoading = true;
      this.$axios
        .post(api.createLeaseUrl, {
          billCode: this.currentDueOverData.code,
          fileName: fileName,
          templateUrl: path,
          templateCode: code,
        })
        .then((res) => {
          this.downloadNoticeLoading = false;
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (data) {
              window.open(data, "_blank");
            } else {
              nError("地址无效");
            }
          }
        })
        .catch(errorHandler("生成失败"))
        .then(() => {
          this.downloadNoticeLoading = false;
        });
    },
  },
  watch: {},
};
</script>

<style lang="less">
.finance-over-view {
  padding: 10px 2%;
  .finance-over-view-top-line {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .finance-over-view-top-line-box {
      width: 15%;
      height: 120px;
      border-radius: 5px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #ffffff;
      i {
        width: 30%;
        font-size: 40px;
      }
      .finance-over-view-top-line-box-info {
        width: 70%;
        text-align: left;
        .finance-over-view-top-line-box-num {
          font-size: 22px;
          font-weight: 600;
          word-wrap: break-word;
          .finance-over-view-top-line-box-unit {
            font-size: 12px;
          }
        }
      }
    }
  }
  .finance-over-view-line {
    height: 240px;
    display: flex;
    justify-content: space-between;
    margin: 40px 0 20px 0;
    padding-bottom: 10px;
    .finance-over-view-line-left-box {
      width: 66%;
    }
    .finance-over-view-line-right-box {
      width: 33%;
    }
    .finance-over-view-line-tab-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .finance-person-count-all {
      display: flex;
      justify-content: center;
      flex-direction: column;
      .finance-person-count-box {
        width: 160px;
        height: 120px;
        padding: 20px 10px;
        border-right: 1px solid #eee;
        border-bottom: 1px solid #eee;
        color: #666666;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .finance-person-count {
          font-size: 32px;
          font-weight: 500;
        }
        .finance-person-tip {
          font-size: 14px;
        }
      }
    }
    .finance-over-view-line-left {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
    }
    .finance-over-view-line-right {
      width: 49%;
      padding: 10px 10px;
      border: 1px solid #eeeeee;
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
    }

    .daily-income-info {
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      .daily-income-info-item {
        color: #666666;
        padding: 0 20px;
        margin: 22px 0;
        .daily-income-info-amount {
          font-size: 24px;
          line-height: 50px;
        }
        .daily-income-info-name {
          font-size: 14px;
          line-height: 24px;
        }
      }
    }

    .el-table {
      thead {
        th {
          padding: 6px 0;
          text-align: center;
          color: #666666;
          background-color: #eff1f5;
        }
      }
      tbody {
        td {
          padding: 6px 0;
          text-align: center;
          color: #ff0000;
        }
      }
    }

    .el-pagination {
      padding: 0;
    }
  }

  .contractDialogForm {
    .el-dialog__header {
      text-align: center;
    }
    .operationBox {
      span {
        cursor: pointer;
        color: #337ab7;
      }
      span:hover {
        color: #00a0e6;
      }
    }
    .contractDialogLine {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      line-height: 30px;
      padding: 0 15px;
    }
    .contractDialogLine:hover {
      background-color: #eeeeee;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Finance/FinanceOverView/FinanceOverView.vue